import { getRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function getTripTemplatesRequests() {
	let url = tripTemplates.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}